<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
  <div class="">
      <el-form inline ref="form" :model="searchform">
        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
         
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value3" :placeholder="$t('searchText.구분')" size="mini"  style="width:120px" >
               <el-option
                      v-for="item in searchform.searchOptions3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
     

        


         
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                   :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
       
     
    
      
        
    </div>
  <div class="d-flex align-items-center mt-2">
    
    
   
  
  </div>
   
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
        show-summary
         :row-class-name="tableRowClassName"
       :summary-method="getSummaries01"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange" @sort-change='tableSortChange'>


        
  
       <el-table-column
        
        :label="$t('nav.아이디')" prop="mem_id" align="center">
         <template slot-scope="scope">
           <span @click="openModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
         </template>
      </el-table-column>

       <el-table-column
        
       :label="$t('msg.카슬머니')"  prop="api_money" align="center">
        <template slot-scope="scope">
          {{formatMoney(scope.row.api_money)}}
        </template>
      </el-table-column>
       


 
          <el-table-column
        :label="$t('msg.카슬롤링')"  prop="mem_eventmoney" align="center">
        <template slot-scope="scope">
          {{formatMoney(scope.row.mem_eventmoney)}}
        </template>
      </el-table-column>

      

       

  <el-table-column
        :label="$t('msg.배팅')"  prop="tt5" align="center" sortable="custom">
        <template slot-scope="scope">
          {{formatMoney(scope.row.tt5)}}
        </template>
      </el-table-column>
        <el-table-column
        :label="$t('msg.당첨')"  prop="tt6" align="center" sortable="custom" >
        <template slot-scope="scope">
          {{formatMoney(scope.row.tt6)}}
        </template>
      </el-table-column>
  
       <el-table-column
        :label="$t('newAdd.수수료')"  prop="tt7" align="center" sortable="custom">
        <template slot-scope="scope">
          {{formatMoney(scope.row.tt7)}}
        </template>
      </el-table-column>
        <el-table-column
        :label="$t('newAdd.손익')" prop="tt8"  align="center" sortable="custom">
        <template slot-scope="scope">
     <span :class="func(scope.row.tt8) " >{{formatMoney(scope.row.tt8)}}</span>
        </template>
      </el-table-column>
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
        
        
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
import layerNew from '../../components/common/layer-new.vue';
    export default {
     components: {
      layer,layerNew
    },
      data(){
        return{
          order:'',
          prop:'',
           otp:'',
          disabled:false,
          domain:window.sessionStorage.getItem('domain'),
   sitetype:window.sessionStorage.getItem('sitetype'),
     bg:window.sessionStorage.getItem('bg'),
     userid:window.sessionStorage.getItem('userid'),
     aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
          buy_good0:'',
          buy_good0_sum:'',
          total_emoney:'',
          total_money:'',
          game_codes:{
              'PWB_NB_MIX':this.$i18n.t("msg.일반조합"),
              'PWB_PB_MIX':this.$i18n.t("msg.파워조합"),
              'PWB_NBPB_MIX':'',
              'PWB':'',
              'PWB_NBPB_MIX3':'',             
            },
          options: [{
                label: this.$i18n.t("msg.대기"),
                value: '1',
               
              }, {
                label: this.$i18n.t("msg.처리중"),
                 value: '2',
                
              }, {
                label: this.$i18n.t("msg.완료"),
                 value: '3',
               
              }, {
                label: this.$i18n.t("msg.취소"),
                 value: '4',
               
              }], 
          searchform:{
            keyword:'',
            time:[],
            searchOptions:[
             
             {
              label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            },
               
           
              {
              label:this.$i18n.t("msg.닉네임"),
              value:'mem_name'
            },
            {
              label:this.$i18n.t("msg.예금주"),
              value:'mem_bankname'
            },
            {
              label:this.$i18n.t("msg.핸드폰"),
              value:'mem_hp'
            },
            {
              label:this.$i18n.t("msg.매장"),
              value:'c_code'
            },
            {
              label:this.$i18n.t("msg.총판"),
              value:'a_code'
            },
            {
              label:this.$i18n.t("msg.부본"),
              value:'b_code'
            }
            ,
            {
              label:this.$i18n.t("msg.본사"),
              value:'s_code'
            }
            ,
            {
              label:this.$i18n.t("msg.마스터"),
              value:'m_code'
            }
            ,
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value:'',
            searchOptions2:[
                
           {
              label:this.$i18n.t("msg.전체"),
              value:''
            },{
              label:this.$i18n.t("msg.적중"),
              value:'win'
            },
            {
              label:this.$i18n.t("msg.배팅"),
              value:'bet'
            },
            {
              label:this.$i18n.t("msg.환불"),
              value:'refund'
            },
            {
              label:this.$i18n.t("msg.취소"),
              value:'cancel'
            },
            ],
            searchOptions3:[
             {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.슬롯"),
              value:'Slots'
            },
            {
              label:this.$i18n.t("msg.라이브"),
              value:'Live Casino'
            },
            
            ],
            value:'',
            value2:'',
            value3:'',


          },
           pickerOptions: {
          },
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
       
          
            
        
             total:0,
             size:0,
             loading: false,
             editIndex:-1,
             creatModel:false,
             tableData: [],
               currentPage:1,
               multipleSelection:[],
              
               
       
          }
          
          
        },
        created() {
          

          this.getList();
          
      
    },
    computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
      
      methods:{
         tableSortChange(column) {
 
                     this.prop= column.prop
                     this.order= column.order
                     
                    this.getList()
                 },
        getSummaries01(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$i18n.t("msg.총");
          }  else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 4) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] = this.formatMoney(sums[index]);
            
            } else {
              sums[index] = '/';
            }
          } else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
           // 搜索事件
      searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                   this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }

              this.currentPage=1;
            


          this.getList();
          
             

        },
         tableRowClassName({row, rowIndex}) {
     
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList();
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList();
              this.loading= true
            },
           handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
      openModel(id){
 let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
           if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: [width+'', '680px'],
             
             });
              return;
           }
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });

        },
         func(state){
                        if(state > 0){
                          return "text-success"
                        }else if(state <0){
                           return "text-danger"
                        }else if(state ===0){
                           return ""
                        }
                      },
       // 批量删除
      deleteAll(){
         this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
             confirmButtonText: this.$i18n.t("msg.삭제"),
             cancelButtonText:this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/apibet_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
        getList(){

        

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
          this.loading = true

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/apibetlist4?fit='+this.prop+'&order='+this.order+'&game_code='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                  
                     let data = response.data
                     this.tableData =data.data
                     this.total = 1
                     this.currentPage =1
                     this.size =100
                 
                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
              this.loading = false
               
            })
        }
        
      
        
      }
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

</style>


// WEBPACK FOOTER //
// src/views/betting4/list.vue